export enum BydRunTimeEnum {
  ENVIRONMENT_URL = './assets/environments/environment.json',
}
